import { Injectable, OnDestroy } from '@angular/core';
import { Browser } from '../model/browser';
import { merge, fromEvent, map, Observable, Observer, Subject, takeUntil } from 'rxjs';
import { ToastService } from '../core/toast/toast.service';

@Injectable({
  providedIn: 'root'
})


export class BrowserDetectorService implements OnDestroy {
  browserObj: Browser | undefined;
  connectionStatus: boolean = true; //false = offline  true = online
  private theEnd$: Subject<void> = new Subject<void>();

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;

  connectionStatus$: Subject<boolean> = new Subject<boolean>();
  connectionSpeed$: Subject<void> = new Subject<void>();

  constructor( private toast: ToastService) {
    this.browserObj = {
      name: this.detectBrowserName(),
      version: this.detectBrowserVersion(),
      isMobile: this.detectBrowserMobile(),
      isIOS: this.isIOS(),
      isIOSStandalone: this.isIOSStandalone(),
    };

    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    //DETECT IF ONLINE
    this.onlineEvent.pipe(takeUntil(this.theEnd$)).subscribe(e => {
      this.connectionStatus$.next(true);
    })

    //DETECT IF OFFLINE
    this.offlineEvent.pipe(takeUntil(this.theEnd$)).subscribe(e => {
      this.connectionStatus$.next(false);
    })


    this.connectionStatus$.pipe(takeUntil(this.theEnd$)).subscribe((val: boolean) => {
      if (val) {

        this.connectionStatus = true;
        
      
      }else{
        this.connectionStatus = false;
        
      }
    })

  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  public get browser() {
    return this.browserObj;
  }

  public getConnectionStatus(): boolean {
    return this.connectionStatus;
  }

  public setConnectionStatus(connection: boolean) {
    this.connectionStatus = connection;
    console.error(this.connectionStatus)
  }

  public detectBrowserMobile(): boolean {
    if (window.matchMedia('screen and (max-width:690px)').matches)
      return true;
    else
      return false;
  }

  private isIOSStandalone() {
    return (this.isIOS() && (('standalone' in window.navigator) || ('standalone' in window.clientInformation)));
  };

  private isIOS(): boolean {
    let userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  }

  private detectBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }



  private detectBrowserVersion() {
    var userAgent = navigator.userAgent, tem,
      matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(matchTest[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return 'IE ' + (tem[1] || '');
    }

    if (matchTest[1] === 'Chrome') {
      tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }

    matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);
    return matchTest.join(' ');
  }


}
